import { useTranslation as useI18nextTranslation, UseTranslationOptions } from "react-i18next";

export type SupportedLanguage = "sk" | "en" | "cs";

export type TranslationNamespace = "common" | "account" | "settings" | "public" | "layout" | "myMachinery" | "marketplace" | "inventory" | "servicing" | "serviceBoard" | "serviceOffers" | "partnerHub" | "chatBot" | "partnerships" | "serviceTracking" | "operations" | "machineEvidence" | "errors";

export const useTranslation = (ns?: TranslationNamespace | TranslationNamespace[], options?: UseTranslationOptions<any>) => {
  const { t: translate, i18n, ready } = useI18nextTranslation(ns, options);

  const changeLanguage = (lng: SupportedLanguage) => {
    return i18n.changeLanguage(lng);
  };

  const getCurrentLanguage = (): SupportedLanguage => {
    return i18n.language as SupportedLanguage;
  };

  const getSupportedLanguages = (): SupportedLanguage[] => {
    return ["sk", "en", "cs"];
  };

  return {
    translate,
    i18n,
    ready,
    changeLanguage,
    getCurrentLanguage,
    getSupportedLanguages,
    isReady: ready
  };
};

export default useTranslation; 